import { get, postJson, del } from '../httpClient';

/**
 * Client for /api/org/:orgId/team/* endpoints (UPDATE.md §3.6.8).
 *
 * Auth is via session cookie (already set up by the marketplace SDK).
 * Errors are thrown by httpClient on non-2xx; callers should catch.
 */
export const orgTeamAPI = {
  /** GET /api/org/:orgId/team */
  list: orgId => get(`/api/org/${orgId}/team`),

  /** POST /api/org/:orgId/team/invite — body: { email, role } */
  invite: (orgId, body) => postJson(`/api/org/${orgId}/team/invite`, body),

  /** POST /api/org/:orgId/team/invite/revoke — body: { email } */
  revokeInvite: (orgId, body) =>
    postJson(`/api/org/${orgId}/team/invite/revoke`, body),

  /** POST /api/org/:orgId/team/invite/accept — body: { ownerId, token } */
  acceptInvite: (orgId, body) =>
    postJson(`/api/org/${orgId}/team/invite/accept`, body),

  /** POST /api/org/:orgId/team/:userId/role — body: { newRole } */
  changeRole: (orgId, userId, body) =>
    postJson(`/api/org/${orgId}/team/${userId}/role`, body),

  /** DELETE /api/org/:orgId/team/:userId */
  removeMember: (orgId, userId) => del(`/api/org/${orgId}/team/${userId}`),
};
